import React, { useState, useEffect } from 'react';
import { AppService, //
AppConfig, AppConfigService, PathUtil, } from '@aperza/util';
// @ts-ignore
import Autocomplete from 'react-autocomplete';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { Message, WebMediaQuery } from '@aperza/ui';
import useTd from '../../hook/UseTd';
const appConfig = AppService.appConfig();
// const SUGGEST_SEARCH = gql`
//   query SuggestSearchQuery($keyword: String, $langCode: String) {
//     suggestSearch {
//       search(keyword: $keyword, langCode: $langCode) {
//         productKeyword
//         productType
//       }
//     }
//   }
// `;
export const SUGGEST_SEARCH = gql `
  query SuggestSearchQuery($keyword: String, $langCode: String) {
    suggestSearch(keyword: $keyword, langCode: $langCode) {
      productKeyword
      productType
    }
  }
`;
/**
 * There are 2 modes
 *
 * If onSuggestChange is null, Suggest will independently handle the keyword change.
 *
 * If onSuggestChange is NOT null, keyword change will be handled by the parent component.
 * If the parent component has more than one Suggest component which must have the same keyword,
 * the parent component must handle the keyword change in order to synchronize the keyword value across
 * multiple Suggest components.
 */
export const Suggest = (props) => {
    let locale = appConfig.langCode;
    const getKeyword = () => AppConfigService.getSearchKeyword() ? AppConfigService.getSearchKeyword() : '';
    const { onSuggestChange, suggestKeyword, inputClassName, rfType } = props;
    let [keyword, setKeyword] = useState(onSuggestChange ? suggestKeyword : getKeyword());
    let [isIME, setIsIME] = useState(false);
    const [timerID, setTimerID] = useState();
    const { data, refetch } = useQuery(SUGGEST_SEARCH, {
        variables: {
            langCode: locale,
            keyword: keyword || '',
        },
        fetchPolicy: 'cache-first',
    });
    const refreshQuery = () => {
        let appConfig = AppService.appConfig();
        if ([AppConfig.APERZA_SEARCH, AppConfig.APERZA_EC].includes(appConfig.serviceType)) {
            return refetch({ langCode: locale, keyword });
        }
    };
    useEffect(() => {
        setKeyword(suggestKeyword);
    }, [suggestKeyword]);
    useEffect(() => {
        //https://aperza.atlassian.net/browse/AB-5486
        if (!AppConfigService.isAperzaSearchCatalogResultPage() &&
            !AppConfigService.isAperzaSearchItemResultPage() &&
            !AppConfigService.isAperzaSearchNewsResultPage() &&
            !AppConfigService.shouldShowMarketplaceTopBanner()) {
            clearTimeout(timerID);
            setTimerID(setTimeout(refreshQuery, 750));
        }
    }, [keyword]);
    let { search } = useTd();
    const onChange = async (e) => {
        let updatedKeyword = e?.target?.value;
        setKeyword(updatedKeyword ? updatedKeyword : '');
        if (onSuggestChange) {
            onSuggestChange(updatedKeyword);
        }
    };
    const onSelect = async (val) => {
        if (val && val.length > 0) {
            const _rfType = props.rfType ? props.rfType : '1101';
            const pathname = AppConfigService.getPath();
            const origin = AppConfigService.getOrigin();
            const { searchWebHost } = appConfig;
            const { langCode } = appConfig;
            const encodedVal = encodeURIComponent(val);
            let url = '#';
            if (PathUtil.isSearchCatalogPage(pathname, langCode) ||
                PathUtil.isCatalogPage(pathname, langCode) ||
                appConfig.isAperzaCatalog) {
                url = `${searchWebHost}/${langCode}/s/catalog/?k=${encodedVal}&rf=${_rfType}&ss=1`;
            }
            else if (appConfig.serviceType === AppConfig.APERZA_NEWS) {
                url = `${origin}/?s=${encodeURIComponent(val)}`;
            }
            else if (pathname.startsWith(`/${langCode}/s/news/`)) {
                url = `${searchWebHost}/${langCode}/s/news/?k=${encodedVal}&rf=${_rfType}&ss=1`;
            }
            else {
                url = `${searchWebHost}/${langCode}/s/model/?k=${encodedVal}&rf=${_rfType}&ss=1`;
                if (AppConfigService.shouldShowMarketplaceTopBanner() || !props.disableMarketplaceBanner) {
                    url = `https://ec${appConfig.baseComDomain}/${langCode}/s/item/?k=${encodedVal}&rf=${_rfType}&ss=1`;
                }
            }
            await search(props.tdId, val, url);
            window.location.href = url;
        }
    };
    const onClickSuggestButton = async () => {
        const val = keyword;
        await onSelect(val.trim());
    };
    const onInputKeyDown = async (e) => {
        if (e.key === 'Enter' && !isIME) {
            await onClickSuggestButton();
        }
    };
    const onCompositionStart = () => {
        setIsIME(true);
    };
    const onCompositionEnd = () => {
        setIsIME(false);
    };
    const isMainPage = AppService.isMainPage();
    const isSearchResult = AppConfigService.isAperzaSearchResultPage();
    const isSearchNewsResult = AppConfigService.isAperzaSearchNewsResultPage();
    const getWrapperStyle = () => {
        const wrapperStyle = {
            display: 'inline-block',
            position: 'relative',
        };
        if (onSuggestChange) {
            wrapperStyle.width = '100%';
        }
        return wrapperStyle;
    };
    const getItems = () => {
        let items = [];
        if (data && data.suggestSearch && Array.isArray(data.suggestSearch)) {
            items = data.suggestSearch.map((product) => {
                return {
                    label: product.productKeyword,
                    productType: product.productType,
                };
            });
        }
        return items;
    };
    return (React.createElement("div", { className: "suggest-container" },
        React.createElement(Autocomplete, { getItemValue: (item) => item.label, items: getItems(), wrapperStyle: getWrapperStyle(), renderInput: (_props) => {
                return (React.createElement("div", { className: `suggest-input-container ${isSearchResult || isSearchNewsResult ? 'search-result' : ''}` },
                    React.createElement("div", { className: `suggest-input ${isMainPage ? 'aw-main-page' : ''}` },
                        onSuggestChange && !isSearchResult && !isSearchNewsResult && false && (React.createElement(WebMediaQuery, { mobileOnly: true },
                            React.createElement("i", { className: "fa fa-search", "aria-hidden": "true" }))),
                        rfType === '1102' && (React.createElement("div", { className: "suggest-input-note" },
                            React.createElement(Message, { messageId: "suggest.title" }))),
                        React.createElement("input", { type: "text", className: inputClassName, ..._props, onKeyDown: onInputKeyDown, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd })),
                    React.createElement("button", { className: `suggest-button ${inputClassName} ${isSearchResult || isSearchNewsResult ? 'search-result' : ''}`, onClick: onClickSuggestButton, type: "button" },
                        React.createElement("i", { className: "fa fa-search", "aria-hidden": "true" }))));
            }, renderMenu: (items) => {
                if (items.length > 0) {
                    return (React.createElement("div", { className: `suggest-list ${isMainPage ? 'aw-main-page' : ''}` }, items));
                }
                return React.createElement("div", { style: { display: 'none' } });
            }, renderItem: (item, isHighlighted) => (React.createElement("div", { key: item.label, style: { background: isHighlighted ? 'lightgray' : 'white' }, className: "suggest-item" },
                React.createElement("span", { className: "name" }, item.label),
                React.createElement("span", { className: "category" }, item.productType))), value: keyword, onChange: onChange, onSelect: onSelect })));
};
Suggest.defaultProps = {
    inputClassName: '',
};
export default Suggest;
